import { type ReactNode } from 'react'
import Button from '../buttons/button'
import TypographyHeading from '../typography/TypographyHeading'

const Section = ({
	callToAction = undefined,
	children = <div></div>,
	title = '',
}: {
	callToAction?: { title: string; onClick: () => {} }
	children: ReactNode
	title?: string
}) => {
	return (
		<section className="m-5 w-auto rounded-lg bg-textPrimaryDark p-8 text-textPrimaryLight dark:bg-uiTertiaryDark dark:text-textPrimaryDark">
			{title && (
				<TypographyHeading size="small" isBold={true}>
					{title}
				</TypographyHeading>
			)}
			<div className="min-h-[86px] py-6">{children}</div>
			{callToAction && (
				<div className="flex w-full items-center justify-center">
					<Button
						variant="tertiary"
						size="medium"
						onClick={() => callToAction.onClick()}
					>
						{title}
					</Button>
				</div>
			)}
		</section>
	)
}

export default Section
